
import Vue from 'vue'
import { URL_SYSTEM } from '@/constants/urls.js'
import { MYME_TYPES } from '@/constants/settings.js'
import { CALENDAR, GENERAL_FILES, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [CALENDAR.STATE.DAY_OFF_DAYS]: []
}

const actions = {
  async [CALENDAR.ACTIONS.GET_DAY_OFF_DATES] ({ commit, dispatch }) {
    const model = {
      url: `${Vue.getBusinessHost()}${URL_SYSTEM}/productionCalendar?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(CALENDAR.MUTATIONS.GET_DAY_OFF_DATES, resp.data || [])
  },
  async [CALENDAR.ACTIONS.LOAD_PRODUCTION_CALENDAR]  ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_SYSTEM}/productionCalendar`,
      model,
      settings: { headers: { 'Content-Type': MYME_TYPES.FORM_DATA } }
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [CALENDAR.ACTIONS.GET_PRODUCTION_CALENDAR_FILE]  ({ commit, dispatch }) {
    const url = `${Vue.getBusinessHost()}${URL_SYSTEM}/productionCalendar/file?${Vue.helpers.getQueryParamsString()}`

    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS, url, { root: true })
  }
}

const mutations = {
  [CALENDAR.MUTATIONS.GET_DAY_OFF_DATES]  (state, days) {
    state[CALENDAR.STATE.DAY_OFF_DAYS] = days
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
